import type * as React from 'react'

import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'

const APIGatewayProvider = ({
  children,
}: {
  children: React.ReactNode
}): React.ReactElement => {
  const client = new ApolloClient({
    cache: new InMemoryCache({
      possibleTypes: {
        Billing: ['MPBilling', 'OBBilling'],
      },
      typePolicies: {
        OBBilling: {
          merge: true,
        },
        // @ts-expect-error (TS2559) Type 'string[][]' has no properties in common with type 'TypePolicy'.
        Channels: [['id', 'name']],
      },
    }),
    link: new HttpLink({
      uri: window.API_GATEWAY_URL,
      credentials: 'include',
      headers: {
        'x-buffer-client-id': 'webapp-app-shell',
        'x-buffer-client-name': 'webapp-app-shell',
        'x-buffer-client-version': window.xBufferClientVersion || 'unknown',
      },
    }),
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default APIGatewayProvider
